import React, { FocusEvent, KeyboardEvent, useState } from 'react';
import NInputTooltip, {
    NInputTooltipProps,
} from '../InputsWithTooltip/NInputTooltip';
import { NInputChip } from '@innersource-nn/novoui-react';

interface NInputWithChipsProps extends NInputTooltipProps {
    name: string;
    labels: string[];
    updateLabels: (inputName: string, newValue: string[]) => void;
}

export default function NInputWithChips({
    name,
    label,
    placeholder,
    labels,
    disabled,
    updateLabels,
    modelValue,
    content,
    className,
}: NInputWithChipsProps) {
    const [value, setValue] = useState<string>(modelValue);

    const handleOnBlur = (event: FocusEvent<HTMLInputElement, Element>) => {
        if (event.target.value !== '') {
            createLabel();
        }
    };
    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter' && value !== '') {
            event.preventDefault();
            updateLabels(name, [...labels, value]);
            createLabel();
        }
    };
    const handleDelete = (tagToDelete: string) => {
        const newLabels = labels.filter((tag) => tag !== tagToDelete);
        updateLabels(name, newLabels);
    };

    const createLabel = () => {
        let newValue = value;
        if (
            name === 'businessOwnerDelegationEmails' &&
            !newValue.includes('@')
        ) {
            newValue += '@novonordisk.com';
        }
        updateLabels(name, [...labels, newValue]);
        setValue('');
    };

    return (
        <div className="flex flex-col gap-8">
            <NInputTooltip
                content={content}
                className={className}
                label={label}
                size="medium"
                variant="outline"
                name={name}
                modelValue={value}
                disabled={disabled}
                placeholder={placeholder}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={handleKeyDown}
                onBlur={handleOnBlur}
            />
            <div className="flex gap-8 overflow-y-auto max-h-100">
                {labels.map((lb, index) => (
                    <NInputChip
                        key={index}
                        label={lb}
                        variant="fill"
                        closable
                        onClose={() => handleDelete(lb)}
                    />
                ))}
            </div>
        </div>
    );
}
